import React from 'react';
import SocketManager from './SocketManager.js';
import useConnectionStatus from './useConnectionStatus.js';
import usePageVisibilityChange from './usePageVisibilityChange';

export const SocketContext = React.createContext({
  socket: SocketManager,
  connected: false,
});

export const SocketProvider = ({ children, handleSocketError }) => {
  const connected = useConnectionStatus(
    SocketManager.getSocketInstance,
    handleSocketError,
  );
  usePageVisibilityChange(SocketManager.getSocketInstance);
  return (
    <SocketContext.Provider
      value={{ socket: SocketManager.getSocketInstance, connected }}
    >
      {children}
    </SocketContext.Provider>
  );
};

// export default SocketProvider;
